export const KHACHHANG_NHOM_LIST_INITING             = 'KHACHHANG_NHOM_LIST_INITING' 

export const KHACHHANG_NHOM_DETAIL_INITING           = 'KHACHHANG_NHOM_DETAIL_INITING'
export const KHACHHANG_NHOM_DETAIL_REQUESTING        = 'KHACHHANG_NHOM_DETAIL_REQUESTING'
export const KHACHHANG_NHOM_DETAIL_SUCCESS           = 'KHACHHANG_NHOM_DETAIL_SUCCESS'
export const KHACHHANG_NHOM_DETAIL_ERROR             = 'KHACHHANG_NHOM_DETAIL_ERROR'   

export const KHACHHANG_NHOM_UPDATE_NHOM_KH            = 'KHACHHANG_NHOM_UPDATE_NHOM_KH'
export const KHACHHANG_NHOM_UPDATE_NHOM_KH_SUCCESS    = 'KHACHHANG_NHOM_UPDATE_NHOM_KH_SUCCESS'
export const KHACHHANG_NHOM_UPDATE_NHOM_KH_ERROR      = 'KHACHHANG_NHOM_UPDATE_NHOM_KH_ERROR'

export const KHACHHANG_NHOM_UPDATE_REQUESTING        = 'KHACHHANG_NHOM_UPDATE_REQUESTING'
export const KHACHHANG_NHOM_UPDATE_SUCCESS           = 'KHACHHANG_NHOM_UPDATE_SUCCESS'
export const KHACHHANG_NHOM_UPDATE_ERROR             = 'KHACHHANG_NHOM_UPDATE_ERROR'   

export const KHACHHANG_NHOM_DETAIL_API               = '/api/v1/khachhang/khachhang_nhom_list_by'  
export const KHACHHANG_NHOM_UPDATE_API               = '/api/v1/khachhang/khachhang_nhom_update_by_ids'  
export const KHACHHANG_NHOM_UPDATE_NHOM_KH_API       = '/api/v1/management/khachhang_nhom_update_info'  


// WEBPACK FOOTER //
// ./src/views/KhachHangNhom/constants.js